import { Component, OnInit } from "@angular/core";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { NavController } from "@ionic/angular";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";

@Component({
  selector: "app-overview-error",
  templateUrl: "./overview-error.component.html",
  styleUrls: ["./overview-error.component.scss"],
})
export class OverviewErrorComponent
  extends DefaultPageComponent
  implements OnInit
{
  headerId = "overview-error";
  titlePage = "Meus dados cadastrais";
  startStage = "1";
  endStage = "1";
  title = "";
  ariaHidden = false;
  analyticsPageGA4: AnalyticsGA4PagesModel;

  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    public domainFactory: DomainFactoryService,
    public returnNativeService: ReturnNativeService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPageGA4();
    this.sendTrackGA4LoadPage();
  }

  ionViewWillEnter() {
    this.headerFocus();
  }

  ngOnInit() {
    this.headerFocus();
  }

  getPageId(): string {
    return this.headerId;
  }

  clickNext() {
    this.nextPage();
  }

  tryAgain() {
    if (this.journeyService.journey === TrackTypes.UPDATE_REGISTRATION) {
      this.router.navigateForward(
        `/?journey=${TrackTypes.UPDATE_REGISTRATION}`
      );
    } else {
      this.router.navigateForward(["overview-status", "overview-user"], {
        queryParams: { journey: "basic-v2" },
      });
    }
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameAlert,
      implementation_team: this.analyticsPageGA4.implementationTeam,
      custom_path:
        this.journeyService.journey === TrackTypes.UPDATE_REGISTRATION
          ? this.analyticsPageGA4.customPathConfiraSeusDados
          : this.analyticsPageGA4.customPathOverview,
    };
    const paramComplementary = {
      detail: "tipo:tela",
      description: this.analyticsPageGA4.titleError,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
  }
}
